import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import * as selectors from '../selector';

import { NoticeHistoryController } from './noticeHistoryController';

import AdditionalLoading from '@/components/AdditionalLoading';
import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import PdfViewer from '@/components/PdfViewer';
import TableBase from '@/components/TableBase';

/**
 * Props
 */
export type Props = {
  /** カテゴリID */
  categoryId: string,
  /** 施設ID */
  nurseryId: string,
  /** 閉じる */
  close: () => void,
};

const NoticeHistory: React.FC<Props> = ({ categoryId, nurseryId, close }) => {
  const dispatch = useDispatch();
  const categoryItems = useSelector(selectors.categoryItemsSelector);
  const content = useSelector(selectors.contentSelector);
  const controller = new NoticeHistoryController(dispatch, categoryId, categoryItems, nurseryId);
  const { rows, columns } = controller;
  const isEnableLoading = controller.getIsEnableLoading();
  const actions = [
    {
      icon: <DownloadIcon />,
      title: 'ダウンロード',
      action: controller.getActionDownload(),
    },
  ];
  return (
    <>
      {content?.attachment && (
        <PdfViewer
          isOpen
          attachment={content.attachment}
          close={controller.getActionClose()}
        />
      )}
      <Dialog
        open
        onClose={close}
        fullScreen
        TransitionComponent={DialogTransition}
      >
        <DialogTitle title="掲示板" />
        <DialogContent>
          <h3>
            <Tooltip title="トップ画面に戻る">
              <IconButton size="large" onClick={close}>
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <span>過去のお知らせ</span>
          </h3>
          <TableBase
            rows={rows}
            columns={columns}
            actions={actions}
            refreshAction={controller.getActionRefreshItem()}
            isPagination={false}
            isShowFooter={false}
            isShowFilter={false}
            onRowClick={controller.getActionSetPreview()}
            hover
          />
          <AdditionalLoading
            isEnableLoading={isEnableLoading}
            onClick={controller.getActionGetItem()}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={close}
            color="primary"
            variant="contained"
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NoticeHistory;
